export class HubsLogbook {
    public id: number;
    public partNumber: string;
    public contract: number;
    public quantity: number;
    public serialNumber?: string;
    public description: string;
    public category: string;
    public originator: string;
    public status: string;
    public actionee: string;
    public createdDate: Date;
    public ogsNumber: string;
    public comments: string;
    public ackDate?: Date;
    public startDate?: Date;
    public completedDate?: Date;
    public userName: string;
    public timeStamp: Date;
    public dropDeadDate?: Date;
    public criticalLevel: string;
    public itemCost: number;
    public isNotEditable: string;
    public baan: string;
    public deviceType: string;
    public criticity: string;
    public issueType: string;

    [key: string]: undefined | string | number | Date;

    constructor(other?: Partial<HubsLogbook>) {
        this.id = other?.id || 0;
        this.partNumber = other?.partNumber || "";
        this.contract = other?.contract || 0;
        this.quantity = other?.quantity || 0;
        this.serialNumber = other?.serialNumber || "";
        this.description = other?.description || "";
        this.category = other?.category || "";
        this.originator = other?.originator || "";
        this.status = other?.status || "";
        this.actionee = other?.actionee || "";
        this.createdDate = other?.createdDate || new Date(0);
        this.ogsNumber = other?.ogsNumber || "";
        this.comments = other?.comments || "";
        this.ackDate = other?.ackDate;
        this.startDate = other?.startDate;
        this.completedDate = other?.completedDate;
        this.userName = other?.userName || "";
        this.timeStamp = other?.timeStamp || new Date(0);
        this.dropDeadDate = other?.dropDeadDate || new Date();
        this.criticalLevel = other?.criticalLevel || "";
        this.itemCost = other?.itemCost || 0;
        this.isNotEditable = "true";
        this.baan = other?.baan || "";
        this.deviceType = other?.deviceType || "";
        this.criticity = other?.criticity || "";
        this.issueType = other?.issueType || "";
    }
}